/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_By_Quantity_HelpInputs */

const en_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Event Groups are created based on the number of events divided by the number of segments. Events are then placed into each new Event Group based on their original order.`)
};

const fr_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De nouveaux groupes d'evenements sont crees en fonction du nombre d'evenements divise par le nombre de segments. Les evenements sont ensuite places dans chaque nouveau groupe d'evenements en fonction de leur ordre d'origine.`)
};

const de_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ereignisgruppen werden erstellt, indem die Anzahl der Ereignisse durch die Anzahl der Segmente geteilt wird. Die Ereignisse werden dann entsprechend ihrer ursprünglichen Reihenfolge in die jeweiligen Ereignisgruppen eingeordnet.`)
};

const it_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I nuovi gruppi di eventi vengono creati in base al numero di eventi diviso per il numero di segmenti. Gli eventi vengono quindi inseriti in ogni nuovo gruppo di eventi in base al loro ordine originale.`)
};

const ru_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые группы событий создаются на основе отношения количества событий к количеству сегментов. Затем события помещаются в каждую новую группу событий в соответствии с их первоначальным порядком.`)
};

const es_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los nuevos grupos de eventos se crean dividiendo el número de eventos entre el número de segmentos. Los eventos se colocan en cada nuevo grupo según su orden original.`)
};

const zh_cn2_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统会根据事件数量除以分段数来创建新的事件组。然后，事件会按照其原始顺序被放入各个新的事件组中。`)
};

const ja_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントグループは、イベント数をセグメント数で割った値に基づいて作成されます。その後、イベントは元の順序に基づいて各新しいイベントグループに配置されます。`)
};

const hi_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं की संख्या को खंडों की संख्या से विभाजित करके नए इवेंट समूह बनाए जाते हैं। फिर घटनाओं को उनके मूल क्रम के अनुसार प्रत्येक नए इवेंट समूह में रखा जाता है।`)
};

const pt_pt2_segment_event_group_by_quantity_help = /** @type {(inputs: Segment_Event_Group_By_Quantity_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos Grupos de Eventos são criados com base no número de eventos dividido pelo número de segmentos. Os eventos são então alocados em cada novo Grupo de Eventos de acordo com a sua ordem original.`)
};

/**
* | output |
* | --- |
* | "New Event Groups are created based on the number of events divided by the number of segments. Events are then placed into each new Event Group based on their..." |
*
* @param {Segment_Event_Group_By_Quantity_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_by_quantity_help = /** @type {((inputs?: Segment_Event_Group_By_Quantity_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_By_Quantity_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_by_quantity_help(inputs)
	if (locale === "de") return de_segment_event_group_by_quantity_help(inputs)
	if (locale === "it") return it_segment_event_group_by_quantity_help(inputs)
	if (locale === "ru") return ru_segment_event_group_by_quantity_help(inputs)
	if (locale === "es") return es_segment_event_group_by_quantity_help(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_by_quantity_help(inputs)
	if (locale === "ja") return ja_segment_event_group_by_quantity_help(inputs)
	if (locale === "hi") return hi_segment_event_group_by_quantity_help(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_by_quantity_help(inputs)
	return en_segment_event_group_by_quantity_help(inputs)
});